import styled from '@emotion/styled'
import Modal from '@/components/common/Modal'

export const Content = styled('div')`
  padding-top: 10px;
  color: #666666;
`

export const ContainerModal = styled(Modal)`
  .ant-modal-footer {
    border-top: none;
    background: #fafafa;
    border-radius: 0 0 8px 8px;
  }
`